import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import chatService from './chatService'

export const GetChat = createAsyncThunk(
  'chat-list',
  async ({rec_id, model_type}: {rec_id: string; model_type: string}, thunkAPI) => {
    try {
      return await chatService.chatList(rec_id, model_type)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createChat = createAsyncThunk('chat-create', async (data: {}, thunkAPI) => {
  try {
    return await chatService.createChat({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AdminContacts = createAsyncThunk('admin-contacts', async (id: string, thunkAPI) => {
  try {
    return await chatService.adminContacts(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UserMsgCount = createAsyncThunk('count-messages', async (_, thunkAPI) => {
  try {
    return await chatService.userMsgCount()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ContactList = createAsyncThunk('contact-list', async (_, thunkAPI) => {
  try {
    return await chatService.contactList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MessageRead = createAsyncThunk('read-msg', async (id: string, thunkAPI) => {
  try {
    return await chatService.messageRead(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentContacts = createAsyncThunk(
  'student-contacts',
  async (id: string, thunkAPI) => {
    try {
      return await chatService.studentContacts(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerContacts = createAsyncThunk(
  'lecturer-contacts',
  async (id: string, thunkAPI) => {
    try {
      return await chatService.lecturerContacts(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PendingMessages = createAsyncThunk('pending-msg', async (id: any, thunkAPI) => {
  try {
    return await chatService.pendingMessages(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type chatState = {
  records: any
  errors: any
  msgCount: any
  contactsList: any
}

const initialState: chatState = {
  records: {
    data: [],
  },
  errors: '',
  msgCount: '',
  contactsList: [],
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserMsgCount.fulfilled, (state, action: PayloadAction<any>) => {
        state.msgCount = action.payload
      })
      .addCase(ContactList.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload
      })
      .addCase(PendingMessages.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload.contacts
        state.msgCount = action.payload.total_unread
      })
  },
})

export const {reset} = chatSlice.actions
export default chatSlice.reducer
